import React from "react"
import styled from "styled-components"

const CodingStyle = styled.div`

  
  #Background {
    fill: ${props => props.theme.text};
  }

  #hair {
    fill: #000;
  }

  #Table {
    fill: ${props => props.theme.background};
  }

  #Vector_37, #Vector_38 {
    fill: ${props => props.theme.laptop};
  }

  svg {
    width: 100% !important;
    height: auto !important;
  }
  margin-top: 20px;

`

function coding(props) {
  return (
    <CodingStyle>
      <svg
        width="1144"
        height="618"
        viewBox="0 0 1144 618"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="undraw_developer_activity_bv83 1" clipPath="url(#clip0)">
          <g id="Background" filter="url(#filter0_d)">
            <path
              d="M1144 396.23C1144.01 413 1141.71 429.691 1137.15 445.83C1132.74 461.388 1126.26 476.282 1117.88 490.11C1117.88 540.21 1084.06 583.51 1034.97 604.11C1014.46 612.632 992.452 616.983 970.24 616.91H217.17C176.92 616.91 139.62 606.05 109.03 587.55C100.275 582.28 91.9705 576.296 84.2 569.66C50.2 540.44 29.12 500.06 29.12 455.46C10.0381 426.077 -0.0799637 391.775 -1.81681e-05 356.74C-1.81681e-05 283.38 43.39 220.3 105.55 192.45C113.804 188.754 122.333 185.704 131.06 183.33C134.147 182.49 137.267 181.737 140.42 181.07C148.826 179.28 157.352 178.11 165.93 177.57C169.03 177.377 172.147 177.267 175.28 177.24H177C180.46 177.24 183.89 177.36 187.3 177.56L188.42 175.66C189.793 173.367 191.2 171.097 192.64 168.85C195.24 164.757 197.967 160.723 200.82 156.75C203.807 152.557 206.923 148.43 210.17 144.37L211 143.37C212.84 141.077 214.72 138.81 216.64 136.57C222.64 129.577 228.973 122.793 235.64 116.22C307.75 45.54 420.72 0.0400085 547.72 0.0400085C646.54 0.0400085 736.87 27.59 806.06 73.11C832.272 58.2766 861.882 50.4933 892 50.52C989.74 50.52 1069 130.89 1069 230.03C1068.99 236.303 1068.65 242.571 1068 248.81C1091.56 265.488 1110.76 287.588 1123.99 313.245C1137.22 338.902 1144.08 367.364 1144 396.23Z"
              fill="white"
            />
            <path
              d="M1117.45 489.851L1117.38 489.97V490.11C1117.38 539.969 1083.72 583.11 1034.78 603.649C1014.33 612.145 992.387 616.483 970.242 616.41H970.24H217.17C177.01 616.41 139.799 605.574 109.289 587.122L109.288 587.122C100.557 581.866 92.2751 575.899 84.5259 569.281C50.6207 540.142 29.62 499.895 29.62 455.46V455.312L29.5393 455.188C10.5103 425.886 0.420256 391.68 0.499982 356.741V356.74C0.499982 283.581 43.7705 220.677 105.754 192.906C113.985 189.221 122.489 186.18 131.191 183.812C134.269 182.975 137.379 182.224 140.523 181.559L140.524 181.559C148.906 179.774 157.408 178.608 165.961 178.069C169.052 177.876 172.159 177.767 175.282 177.74C175.283 177.74 175.284 177.74 175.284 177.74L177 177.74C180.448 177.74 183.869 177.86 187.271 178.059L187.576 178.077L187.731 177.814L188.849 175.917C188.849 175.916 188.85 175.916 188.85 175.915C190.22 173.627 191.624 171.362 193.061 169.12L193.062 169.118C195.657 165.033 198.378 161.007 201.226 157.042L201.227 157.04C204.208 152.855 207.318 148.737 210.558 144.685C210.559 144.684 210.56 144.683 210.56 144.682L211.385 143.689L211.39 143.683C213.227 141.394 215.103 139.131 217.019 136.896C223.01 129.913 229.334 123.14 235.991 116.576C307.996 46.0001 420.834 0.540009 547.72 0.540009C646.449 0.540009 736.682 28.0652 805.785 73.5277L806.04 73.6956L806.306 73.5452C832.443 58.7543 861.968 50.9934 892 51.02C989.457 51.02 1068.5 131.16 1068.5 230.03C1068.49 236.285 1068.15 242.536 1067.5 248.758L1067.47 249.049L1067.71 249.218C1091.21 265.85 1110.36 287.888 1123.55 313.474C1136.74 339.06 1143.58 367.443 1143.5 396.229C1143.51 412.954 1141.21 429.6 1136.67 445.694C1132.28 461.209 1125.81 476.061 1117.45 489.851Z"
              stroke="white"
            />
          </g>
          <path
            id="Vector"
            opacity="0.2"
            d="M584.51 111H559V136.51H584.51V111Z"
            fill="#FF6961"
          />
          <path
            id="Vector_2"
            opacity="0.2"
            d="M688.92 175.65H663.41V201.16H688.92V175.65Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_3"
            d="M723.79 175.65H698.28V201.16H723.79V175.65Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_4"
            opacity="0.2"
            d="M758.65 175.65H733.14V201.16H758.65V175.65Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_5"
            opacity="0.7"
            d="M793.52 175.65H768.01V201.16H793.52V175.65Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_6"
            opacity="0.4"
            d="M688.92 207.96H663.41V233.47H688.92V207.96Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_7"
            opacity="0.2"
            d="M723.79 207.96H698.28V233.47H723.79V207.96Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_8"
            opacity="0.2"
            d="M758.65 207.96H733.14V233.47H758.65V207.96Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_9"
            opacity="0.2"
            d="M793.52 207.96H768.01V233.47H793.52V207.96Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_10"
            opacity="0.2"
            d="M654.05 240.28H628.54V265.79H654.05V240.28Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_11"
            d="M688.92 240.28H663.41V265.79H688.92V240.28Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_12"
            opacity="0.2"
            d="M723.79 240.28H698.28V265.79H723.79V240.28Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_13"
            opacity="0.2"
            d="M758.65 240.28H733.14V265.79H758.65V240.28Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_14"
            opacity="0.2"
            d="M793.52 240.28H768.01V265.79H793.52V240.28Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_15"
            opacity="0.2"
            d="M688.92 272.59H663.41V298.1H688.92V272.59Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_16"
            opacity="0.2"
            d="M723.79 272.59H698.28V298.1H723.79V272.59Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_17"
            opacity="0.2"
            d="M758.65 272.59H733.14V298.1H758.65V272.59Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_18"
            opacity="0.2"
            d="M793.52 272.59H768.01V298.1H793.52V272.59Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_19"
            opacity="0.2"
            d="M688.92 304.91H663.41V330.42H688.92V304.91Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_20"
            opacity="0.2"
            d="M723.79 304.91H698.28V330.42H723.79V304.91Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_21"
            opacity="0.2"
            d="M758.65 304.91H733.14V330.42H758.65V304.91Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_22"
            opacity="0.2"
            d="M793.52 304.91H768.01V330.42H793.52V304.91Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_23"
            opacity="0.2"
            d="M828.38 304.91H802.87V330.42H828.38V304.91Z"
            fill="#6C63FF"
          />
          <path
            id="Vector_24"
            d="M734.52 398.76C753.778 398.76 769.39 383.148 769.39 363.89C769.39 344.632 753.778 329.02 734.52 329.02C715.262 329.02 699.65 344.632 699.65 363.89C699.65 383.148 715.262 398.76 734.52 398.76Z"
            fill="#767D9F"
          />
          <path
            id="Vector_25"
            d="M732.71 319.53C736.19 334.717 739.143 350.017 741.57 365.43C742.3 370.01 742.95 374.84 741.29 379.17C739.9 382.78 737.07 385.6 734.85 388.76C732.63 391.92 730.95 395.97 732.3 399.59C733.65 403.21 737.59 405.19 741.35 406.21C752.11 409.11 763.58 407 774.29 403.86C779.139 402.612 783.788 400.686 788.1 398.14C792.64 395.26 796.36 391.26 799.78 387.14C815.39 368.21 825.61 345.49 835.23 322.91C829.049 323.473 822.822 322.556 817.065 320.237C811.307 317.917 806.185 314.261 802.12 309.57C798.18 304.94 795.29 298.49 797.51 292.83C791 296.4 783.27 296.64 776.26 299.08C771.913 300.74 767.728 302.799 763.76 305.23C758.973 307.997 754.213 310.817 749.48 313.69C744.07 316.95 739 319.85 732.71 319.53Z"
            fill="#AE6E79"
          />
          <path
            id="Vector_26"
            d="M805.64 345.71C799.53 357.6 791.58 369.03 780.23 376.11C768.88 383.19 753.6 385.11 742.23 378.11C736.63 374.69 732.39 369.49 727.5 365.11C722.61 360.73 716.5 356.98 709.93 357.55C702.69 358.18 697.02 363.83 692.17 369.24C684.81 377.46 677.7 386.03 672.49 395.76C662.49 414.46 660.12 436.32 660.56 457.52C661 478.72 664.07 499.81 664.14 521.01C664.24 547.09 659.82 572.96 655.35 598.65C696.45 593.59 737.6 604.65 778.79 608.84C805.15 611.55 831.71 611.49 858.21 611.42C862.87 611.42 867.83 611.3 871.71 608.72C874.082 606.99 875.999 604.712 877.3 602.08C880.96 595.33 882.43 587.63 883.45 580.02C886.04 560.8 886.12 541.34 886.19 521.94C886.37 474.94 886.54 427.77 880.57 381.14C879.1 369.67 877.22 358.14 872.82 347.41C868.42 336.68 861.24 326.81 851.2 321.06C844.75 317.36 829.8 310.92 822.2 314.65C813.67 318.81 809.73 337.75 805.64 345.71Z"
            fill="#767D9F"
          />
          <path
            id="Vector_27"
            d="M808.68 478.43C807.13 449.43 800.82 418.48 814.25 392.74C817.55 386.42 805.71 378.53 809.37 372.41C813.836 364.948 817.223 356.892 819.43 348.48C820.19 345.59 820.8 342.53 820.08 339.63C818.75 334.34 813.52 331.19 809.08 327.97C804.18 324.41 801.66 313.56 800.08 307.69C798.5 301.82 812.65 308.89 818.34 306.8C826.24 303.91 836.28 305.73 844.16 308.66C848.56 310.28 853.34 310.42 858.03 310.54C867.14 310.78 876.28 311.01 885.32 309.89C889.38 309.38 893.45 308.61 897.53 308.84C907.94 309.43 916.99 316.55 923.15 324.97C929.31 333.39 933.23 343.2 938.28 352.32C942.49 359.92 947.51 367.1 951.1 375.01C954.28 382.01 956.29 389.53 958.28 397.01L963.41 416.2C964.307 418.945 964.733 421.823 964.67 424.71C964.41 427.78 963.05 430.64 961.67 433.37C956.452 443.489 950.195 453.037 943 461.86C932.21 475.09 919.11 487.02 912.7 502.86C910.2 509.03 908.81 515.59 907.54 522.13C902.42 548.287 898.78 574.713 896.64 601.28C884.955 595.873 872.707 591.778 860.12 589.07C853.845 587.728 847.503 586.726 841.12 586.07C835.53 585.49 828.32 586.59 823 585.07C814.1 582.54 813.12 567.49 811.77 559.61C809.61 547.06 809.18 534.29 809.1 521.61C809 507.19 809.45 492.8 808.68 478.43Z"
            fill="#504E79"
          />
          <path
            id="Vector_28"
            d="M613.23 424.2C617.44 448.2 622.08 472.27 631.23 494.82C631 495.04 630.77 495.24 630.54 495.44C629.73 496.13 628.89 496.78 628.01 497.44C625.96 498.88 623.71 500.1 622.01 501.98C621.366 502.699 620.858 503.53 620.51 504.43C620.196 505.133 620.033 505.895 620.033 506.665C620.033 507.435 620.196 508.197 620.51 508.9C615.74 511.01 610.2 510.36 604.85 510.16C600.24 509.99 595.77 510.16 592.07 512.69C586.93 516.23 585.38 523.03 584.55 529.21C584.243 531.463 583.98 533.72 583.76 535.98C583.547 538.08 583.373 540.187 583.24 542.3C582.787 549.291 582.723 556.302 583.05 563.3C583.103 564.58 583.173 565.86 583.26 567.14C566.92 566.75 552.03 558.23 537.94 549.95C534.72 548.06 531.4 546.07 529.31 542.95C527.384 539.886 526.569 536.253 527 532.66C527 532.15 527.09 531.66 527.16 531.14C527.608 528.172 528.376 525.262 529.45 522.46C533.858 510.524 540.356 499.468 548.64 489.81C552.22 485.63 556.25 481.54 557.92 476.29C558.65 474 558.92 471.57 559.66 469.29C562.98 459.41 574.96 454.74 579.06 445.15C580.06 442.86 580.52 440.35 581.76 438.15C582.876 436.322 584.316 434.712 586.01 433.4C586.74 432.79 587.5 432.2 588.25 431.61C595.277 426.103 602.047 420.287 608.56 414.16C609.773 413.02 610.973 411.867 612.16 410.7C612.002 415.226 612.361 419.755 613.23 424.2Z"
            fill="#504E79"
          />
          <path
            id="Vector_29"
            d="M714 353.22C712.56 354.74 711 356.17 709.47 357.59L709.06 357.96L707.44 359.46C704.5 361.998 701.955 364.96 699.89 368.25L699.72 368.53C694.62 377.66 696.51 388.9 697.93 399.27C699.691 412.193 700.483 425.229 700.3 438.27C700.04 456.27 697.92 474.15 697.88 492.13C697.88 496.21 697.97 500.28 698.15 504.36C698.44 510.99 698.94 517.61 699.54 524.23C700.19 531.49 700.97 538.74 701.7 545.99C702.28 551.6 702.83 557.2 703.29 562.8C703.52 565.7 703.74 568.59 703.92 571.49C704.13 574.89 704.3 578.3 704.4 581.7C704.47 583.86 704.51 586.01 704.51 588.17C704.51 589.4 704.51 590.62 704.51 591.84C704.51 594.18 704.447 596.513 704.32 598.84C704.187 601.833 703.983 604.833 703.71 607.84C703.4 611.11 702.85 614.68 700.55 616.98C700.41 617.12 700.26 617.25 700.11 617.38L696.87 616.98C674.535 614.306 651.986 613.904 629.57 615.78C630.06 612.4 630.51 609.03 630.95 605.64C631.15 604.04 631.35 602.43 631.54 600.82C631.76 598.98 631.97 597.14 632.17 595.3C632.4 593.3 632.61 591.3 632.81 589.3C633.33 584.147 633.787 578.99 634.18 573.83C634.76 566.303 635.2 558.763 635.5 551.21C635.647 547.603 635.76 543.993 635.84 540.38C635.953 535.9 636.007 531.417 636 526.93C636 522.57 635.963 518.203 635.89 513.83C635.89 512.39 635.83 510.95 635.71 509.52C635.624 508.232 635.447 506.953 635.18 505.69C634.437 502.779 633.433 499.941 632.18 497.21C631.96 496.69 631.75 496.21 631.54 495.66C631.42 495.39 631.31 495.11 631.2 494.84C636.96 489.71 641.06 482.84 645 476.08C651.39 465.19 657.93 453.82 659 441.24C660.07 428.66 653.82 414.53 641.8 410.69C638.53 409.69 635.07 409.41 631.7 408.82C628.52 408.26 621.89 406.99 618.21 404.71C616.21 406.763 614.21 408.78 612.21 410.76C612.331 407.739 613.07 404.775 614.38 402.05L615.8 402.12C615.684 401.8 615.63 401.46 615.64 401.12C615.64 400.05 616.38 398.84 617.96 397.5C622.67 393.5 630.08 392.61 633.05 387.2C634.29 384.95 634.5 382.27 635.5 379.91C638.37 373.18 646.61 370.7 651.57 365.32C656.53 359.94 657.77 352.32 661.78 346.32C664.775 341.938 668.93 338.476 673.78 336.32C674.18 336.13 674.59 335.94 675 335.77C683.3 332.22 693.16 331.41 701.76 331.43C705.1 331.43 713.76 331.53 718 333.22C718.688 333.466 719.317 333.85 719.85 334.35C724.37 339.27 717.34 349.66 714 353.22Z"
            fill="#504E79"
          />
          <path
            id="Vector_30"
            d="M614.72 401.35C622.445 399.024 630.555 398.257 638.579 399.093C646.603 399.929 654.38 402.352 661.46 406.22C668.66 410.22 675.12 415.8 679.08 423C685.03 433.8 684.77 446.82 684.35 459.15C684.14 465.32 683.87 471.71 681.15 477.25C678 483.66 672.06 488.06 666 491.66C662.204 494.082 658.045 495.881 653.68 496.99C646.96 498.45 639.98 497.21 633.21 495.99C625.85 494.63 617.95 492.99 612.84 487.51C609.84 484.33 608.2 480.2 606.58 476.16C604.253 470.327 601.92 464.5 599.58 458.68C595.53 448.57 594.16 440.16 599.51 430.31C601.94 425.82 604.91 421.62 607.31 417.1C608.51 414.8 612.81 401.94 614.72 401.35Z"
            fill="#504E79"
          />
          <path
            id="Table"
            d="M1035 574.22V604.12C1014.49 612.641 992.482 616.993 970.27 616.92H700.58C700.44 617.06 700.29 617.19 700.14 617.32L696.9 616.92H217.17C176.92 616.92 139.62 606.06 109.03 587.56V541.91L339.75 515.28H339.93L474.29 526.66L509.06 529.66L527.12 531.19L564.5 534.36L583.73 535.99L611.73 538.37L615.67 538.7L635.85 540.41L663.23 542.66L701.73 545.92L765.91 551.37L811.06 555.2L885.2 561.49L899.3 562.68L900.82 562.81L902.14 562.92L920.76 564.5L941.2 566.24L943.57 566.44L1035 574.22Z"
            fill="white"
          />
          <path
            id="Vector_31"
            d="M764 573.12L474.86 523.77L463.65 580.46L596.19 596.33L637 601.44L749.26 579.33L764 573.12Z"
            fill="#9C9CA1"
          />
          <path
            id="Vector_32"
            d="M677.17 512.97C681.68 512.55 686.25 511.84 690.31 509.84C695.31 507.35 699.2 503.06 703.83 499.9C714.01 492.9 727.63 491.96 739.3 495.98C750.97 500 760.71 508.61 767.53 518.89C772.06 525.74 775.46 534.48 772.26 542.04C771.162 544.351 769.778 546.515 768.14 548.48L759.8 559.38C758.216 561.671 756.309 563.722 754.14 565.47C751.02 567.74 747.14 568.67 743.32 569.23C733.17 570.71 722.84 569.87 712.61 570.55C695.04 571.72 677.88 577.38 660.27 577.19C650.15 577.08 640.16 575.04 630.27 573L586.5 564C578.88 562.44 570.27 560.16 566.68 553.25C565.07 550.14 564.77 546.54 564.58 543.04C564.06 533.4 564.58 522.68 571.26 515.73C577.54 509.21 587.47 507.15 594.97 502.33C604.15 496.42 607.18 498.33 616.86 502.77C635.745 511.322 656.523 514.837 677.17 512.97Z"
            fill="#AE6E79"
          />
          <g id="Hands">
            <path
              id="Vector_33"
              opacity="0.05"
              d="M677.17 512.97C681.68 512.55 686.25 511.84 690.31 509.84C695.31 507.35 699.2 503.06 703.83 499.9C714.01 492.9 727.63 491.96 739.3 495.98C750.97 500 760.71 508.61 767.53 518.89C772.06 525.74 775.46 534.48 772.26 542.04C771.162 544.351 769.778 546.515 768.14 548.48L759.8 559.38C758.216 561.671 756.309 563.722 754.14 565.47C751.02 567.74 747.14 568.67 743.32 569.23C733.17 570.71 722.84 569.87 712.61 570.55C695.04 571.72 677.88 577.38 660.27 577.19C650.15 577.08 640.16 575.04 630.27 573L586.5 564C578.88 562.44 570.27 560.16 566.68 553.25C565.07 550.14 564.77 546.54 564.58 543.04C564.06 533.4 564.58 522.68 571.26 515.73C577.54 509.21 587.47 507.15 594.97 502.33C604.15 496.42 607.18 498.33 616.86 502.77C635.745 511.322 656.523 514.837 677.17 512.97Z"
              fill="black"
            />
            <path
              id="Vector_34"
              d="M852.94 499.26C840.66 504.01 828.31 508.78 815.45 511.61C793.89 516.36 771.33 515.61 749.94 521.04C738.64 523.92 727.41 528.56 715.8 527.62C710.61 527.2 705.6 525.62 700.55 524.42C672.18 517.42 639.93 519.69 616.89 537.69C609.01 543.84 602.56 551.51 596.71 559.69C595.458 561.457 594.612 563.478 594.232 565.61C593.853 567.742 593.948 569.931 594.513 572.022C595.078 574.112 596.097 576.052 597.499 577.702C598.9 579.353 600.649 580.674 602.62 581.57C611.58 585.691 621.178 588.251 631 589.14C644.13 590.3 657.32 588.44 670.38 586.58C689.76 583.83 709.15 581.07 728.48 577.98C735.42 576.87 742.36 575.72 749.34 574.84C799.57 568.49 850.71 576.21 901.07 570.91C906.16 570.37 911.34 569.67 915.97 567.5C927.69 562 933.49 547.5 931.07 534.76C928.65 522.02 919.31 511.43 908.07 504.93C898.65 499.46 888.49 497.25 878 494.93C868.26 492.66 862.32 495.66 852.94 499.26Z"
              fill="#AE6E79"
            />
          </g>
          <path
            id="Vector_35"
            opacity="0.1"
            d="M960.67 423.1C966.21 430.36 967.39 440.1 966.79 449.19C966.19 458.28 964.03 467.27 963.71 476.4C963.27 488.92 966.29 501.4 965.78 513.88C965.42 522.61 963.35 531.17 960.9 539.55C958.01 549.44 953.83 560.07 944.7 564.82C932.58 571.13 907.16 567.58 894.41 572.52C895.57 565.29 906.69 554.82 907.85 547.59C908.65 542.59 909.46 537.45 908.6 532.44C907.5 526.05 903.75 520.38 899.3 515.66C892.22 508.15 882.98 502.5 872.83 500.66C862.68 498.82 837.83 500.33 829.71 506.74C828.71 500.12 847.31 493.74 853.85 492.31C857.11 491.58 860.85 491.99 863.46 489.92C868.46 486 864.83 478.19 865.07 471.92C865.26 466.92 868.18 462.34 868.77 457.34C869.77 449.34 864.55 441.19 866.6 433.34C867.36 430.44 869.05 427.89 870.22 425.13C873.78 416.68 872.22 407.04 870.32 398.06C869.14 392.42 867.99 386.06 871.13 381.25C874.04 376.76 882.3 392.75 887.59 392.01C905.06 389.56 920.87 376.61 934.98 387.21C942.17 392.61 943.11 398.21 945.98 405.92C948.77 413.26 956 417.02 960.67 423.1Z"
            fill="black"
          />
          <path
            id="Vector_36"
            d="M963.67 423.1C969.21 430.36 970.39 440.1 969.79 449.19C969.19 458.28 967.03 467.27 966.71 476.4C966.27 488.92 969.29 501.4 968.78 513.88C968.42 522.61 966.35 531.17 963.9 539.55C961.01 549.44 956.83 560.07 947.7 564.82C935.58 571.13 910.16 567.58 897.41 572.52C898.57 565.29 909.69 554.82 910.85 547.59C911.65 542.59 912.46 537.45 911.6 532.44C910.5 526.05 906.75 520.38 902.3 515.66C895.22 508.15 885.98 502.5 875.83 500.66C865.68 498.82 840.83 500.33 832.71 506.74C831.71 500.12 850.31 493.74 856.85 492.31C860.11 491.58 863.85 491.99 866.46 489.92C871.46 486 867.83 478.19 868.07 471.92C868.26 466.92 871.18 462.34 871.77 457.34C872.77 449.34 867.55 441.19 869.6 433.34C870.36 430.44 872.05 427.89 873.22 425.13C876.78 416.68 875.22 407.04 873.32 398.06C872.14 392.42 870.99 386.06 874.13 381.25C877.04 376.76 882.73 375.06 888.02 374.31C905.732 371.914 923.678 376.544 938.02 387.21C945.21 392.61 946.15 398.21 949.02 405.92C951.77 413.26 959 417.02 963.67 423.1Z"
            fill="#504E79"
          />
          <g id="Laptop">
            <path
              id="Vector_37"
              d="M614.33 598.6L759.19 571.37C759.915 571.231 760.661 571.255 761.376 571.438C762.09 571.622 762.755 571.962 763.323 572.433C763.891 572.905 764.348 573.496 764.66 574.164C764.972 574.833 765.133 575.562 765.13 576.3V576.3C765.133 577.471 764.726 578.605 763.978 579.506C763.231 580.407 762.191 581.017 761.04 581.23L619.57 607.72L614.33 598.6Z"
              fill="#3A464B"
            />
            <path
              id="Vector_38"
              d="M302 375.72L356.37 576.66C357.037 579.122 358.439 581.322 360.388 582.968C362.337 584.613 364.741 585.625 367.28 585.87L612 609.38C613.994 609.572 616.006 609.284 617.866 608.539C619.726 607.794 621.381 606.614 622.691 605.098C624.001 603.582 624.929 601.774 625.397 599.826C625.865 597.878 625.859 595.846 625.38 593.9L565.84 351.52C565.132 348.639 563.425 346.102 561.022 344.361C558.62 342.62 555.678 341.787 552.72 342.01L313.13 359.93C311.29 360.073 309.505 360.62 307.901 361.532C306.297 362.445 304.915 363.699 303.852 365.208C302.789 366.716 302.072 368.44 301.752 370.257C301.431 372.074 301.516 373.939 302 375.72V375.72Z"
              fill="#3A464B"
            />
          </g>
          <path
            id="Vector_39"
            d="M787.11 414.93C801.966 414.93 814.01 402.73 814.01 387.68C814.01 372.63 801.966 360.43 787.11 360.43C772.254 360.43 760.21 372.63 760.21 387.68C760.21 402.73 772.254 414.93 787.11 414.93Z"
            fill="white"
          />
          <path
            id="Vector_40"
            d="M809.2 337.97C809.2 337.97 814.87 354.83 798.14 361.92L796 365.66L806.48 376C806.48 376 819.4 352.43 818 344.06C818 344.06 816 335.56 809.2 337.97Z"
            fill="white"
          />
          <path
            id="Vector_41"
            d="M790.2 414.93C804.526 414.93 816.14 403.316 816.14 388.99C816.14 374.664 804.526 363.05 790.2 363.05C775.874 363.05 764.26 374.664 764.26 388.99C764.26 403.316 775.874 414.93 790.2 414.93Z"
            fill="#3A464B"
          />
          <path
            id="Vector_42"
            d="M818.13 347.89L814.01 341.09L808.01 340.24C809.29 317.85 803.48 311.18 803.48 311.18L802.13 311.05L796.25 310.48L785.19 299V295.74C800.73 297.59 809.32 304.97 813.96 313.62C822.16 328.8 818.13 347.89 818.13 347.89Z"
            fill="#3A464B"
          />
          <path
            id="Vector_43"
            opacity="0.1"
            d="M802.18 306.93V311.05L796.3 310.48L785.24 299C785.24 299 802.35 302.83 802.18 306.93Z"
            fill="black"
            stroke="#4C4981"
            strokeMiterlimit="10"
          />
          <path
            id="Vector_44"
            opacity="0.1"
            d="M818.13 347.89L814.01 341.09V313.66C822.16 328.8 818.13 347.89 818.13 347.89Z"
            fill="black"
            stroke="#4C4981"
            strokeMiterlimit="10"
          />
          <path
            id="Vector_45"
            d="M742.267 399.653C749.168 395.668 748.871 382.233 741.603 369.644C734.335 357.056 722.848 350.081 715.947 354.066C709.045 358.05 709.342 371.486 716.61 384.074C723.878 396.663 735.365 403.638 742.267 399.653Z"
            fill="white"
          />
          <path
            id="Vector_46"
            d="M733 374.66C740.27 387.25 749.19 395.66 742.29 399.66C735.39 403.66 715.29 401.66 708.02 389.06C700.75 376.46 707.35 359.06 714.25 355.06C721.15 351.06 725.72 362.04 733 374.66Z"
            fill="#3A464B"
          />
          <path
            id="Vector_47"
            opacity="0.1"
            d="M797.73 283.96C797.73 324.19 770.2 362.96 729.97 362.96C710.649 362.96 692.119 355.285 678.457 341.623C664.795 327.961 657.12 309.431 657.12 290.11C657.12 270.789 664.795 252.259 678.457 238.597C692.119 224.935 710.649 217.26 729.97 217.26C770.2 217.3 797.73 243.72 797.73 283.96Z"
            fill="black"
          />
          <path
            id="Vector_48"
            d="M729.97 361C770.204 361 802.82 328.384 802.82 288.15C802.82 247.916 770.204 215.3 729.97 215.3C689.736 215.3 657.12 247.916 657.12 288.15C657.12 328.384 689.736 361 729.97 361Z"
            fill="#AE6E79"
          />
          <path
            id="Vector_49"
            opacity="0.1"
            d="M810.2 262.14C809.71 263.62 808.97 265.28 807.47 265.71C806.371 265.858 805.253 265.699 804.24 265.25C797.35 263.13 789.99 265.46 783.04 267.37C770.47 270.83 756.12 272.68 745.16 265.64C737.37 260.64 732.25 251.64 723.57 248.5C701.94 240.5 688.84 266.38 677.36 279.94C676.215 281.449 674.834 282.763 673.27 283.83C670.882 285.074 668.194 285.625 665.51 285.42C648.09 285.11 631.68 271.99 627.51 255.05C627.28 254.05 627.08 253.05 626.93 252.05C626.93 252.14 626.93 252.22 626.88 252.31C626.419 255.675 626.633 259.098 627.51 262.38C631.63 279.32 648.04 292.44 665.51 292.75C668.194 292.955 670.882 292.404 673.27 291.16C674.834 290.093 676.215 288.779 677.36 287.27C688.84 273.71 701.94 247.87 723.57 255.83C732.25 259.02 737.37 267.98 745.16 272.97C756.16 279.97 770.47 278.16 783.04 274.7C790.04 272.79 797.35 270.46 804.24 272.58C805.253 273.029 806.371 273.188 807.47 273.04C808.97 272.61 809.71 270.95 810.2 269.47C813.637 259.077 815.155 248.146 814.68 237.21C814.386 245.691 812.877 254.087 810.2 262.14Z"
            fill="black"
          />
          <g id="midddle light">
            <path
              id="Vector_50"
              opacity="0.4"
              d="M200.79 240.28H175.28V265.79H200.79V240.28Z"
              fill="#FF1205"
            />
            <path
              id="Vector_51"
              opacity="0.4"
              d="M235.66 272.59H210.15V298.1H235.66V272.59Z"
              fill="#FF1205"
            />
            <g id="Group 22">
              <path
                id="Vector_52"
                opacity="0.4"
                d="M444.86 175.65H419.35V201.16H444.86V175.65Z"
                fill="#FF1205"
              />
              <path
                id="Vector_53"
                opacity="0.4"
                d="M444.86 207.96H419.35V233.47H444.86V207.96Z"
                fill="#FF1205"
              />
              <path
                id="Vector_54"
                opacity="0.4"
                d="M444.86 240.28H419.35V265.79H444.86V240.28Z"
                fill="#FF1205"
              />
              <path
                id="Vector_55"
                opacity="0.2"
                d="M444.86 272.59H419.35V298.1H444.86V272.59Z"
                fill="#FF1205"
              />
            </g>
            <path
              id="Vector_56"
              opacity="0.4"
              d="M549.45 143.33H523.94V168.84H549.45V143.33Z"
              fill="#FF1205"
            />
            <path
              id="Vector_57"
              opacity="0.4"
              d="M549.45 175.65H523.94V201.16H549.45V175.65Z"
              fill="#FF1205"
            />
            <path
              id="Vector_58"
              opacity="0.4"
              d="M479.72 143.33H454.21V168.84H479.72V143.33Z"
              fill="#FF1205"
            />
            <path
              id="Vector_59"
              opacity="0.4"
              d="M479.72 207.96H454.21V233.47H479.72V207.96Z"
              fill="#FF1205"
            />
            <path
              id="Vector_60"
              opacity="0.4"
              d="M619.19 143.33H593.68V168.84H619.19V143.33Z"
              fill="#FF1205"
            />
            <path
              id="Vector_61"
              opacity="0.4"
              d="M654.05 143.33H628.54V168.84H654.05V143.33Z"
              fill="#FF1205"
            />
            <path
              id="Vector_62"
              opacity="0.4"
              d="M654.05 175.65H628.54V201.16H654.05V175.65Z"
              fill="#FF1205"
            />
            <path
              id="Vector_63"
              opacity="0.4"
              d="M654.05 207.96H628.54V233.47H654.05V207.96Z"
              fill="#FF1205"
            />
            <path
              id="Vector_64"
              opacity="0.4"
              d="M863.25 143.33H837.74V168.84H863.25V143.33Z"
              fill="#FF1205"
            />
            <path
              id="Vector_65"
              opacity="0.4"
              d="M584.32 207.96H558.81V233.47H584.32V207.96Z"
              fill="#FF1205"
            />
            <path
              id="Vector_66"
              opacity="0.4"
              d="M619.19 207.96H593.68V233.47H619.19V207.96Z"
              fill="#FF1205"
            />
            <path
              id="Vector_67"
              opacity="0.4"
              d="M932.98 207.96H907.47V233.47H932.98V207.96Z"
              fill="#FF1205"
            />
            <path
              id="Vector_68"
              opacity="0.4"
              d="M967.85 272.59H942.34V298.1H967.85V272.59Z"
              fill="#FF1205"
            />
            <path
              id="Vector_69"
              opacity="0.4"
              d="M723.79 143.33H698.28V168.84H723.79V143.33Z"
              fill="#FF1205"
            />
            <path
              id="Vector_70"
              opacity="0.4"
              d="M758.65 143.33H733.14V168.84H758.65V143.33Z"
              fill="#FF1205"
            />
            <path
              id="Vector_71"
              opacity="0.4"
              d="M863.25 175.65H837.74V201.16H863.25V175.65Z"
              fill="#FF1205"
            />
          </g>
          <g id="low mid light">
            <path
              id="Vector_72"
              opacity="0.7"
              d="M305.39 175.65H279.88V201.16H305.39V175.65Z"
              fill="#FF3D33"
            />
            <path
              id="Vector_73"
              opacity="0.7"
              d="M305.39 207.96H279.88V233.47H305.39V207.96Z"
              fill="#FF3D33"
            />
            <path
              id="Vector_74"
              opacity="0.7"
              d="M305.39 240.28H279.88V265.79H305.39V240.28Z"
              fill="#FF3D33"
            />
            <path
              id="Vector_75"
              opacity="0.7"
              d="M340.26 143.33H314.75V168.84H340.26V143.33Z"
              fill="#FF3D33"
            />
            <path
              id="Vector_76"
              opacity="0.7"
              d="M340.26 175.65H314.75V201.16H340.26V175.65Z"
              fill="#FF3D33"
            />
            <path
              id="Vector_77"
              opacity="0.7"
              d="M340.26 207.96H314.75V233.47H340.26V207.96Z"
              fill="#FF3D33"
            />
            <path
              id="Vector_78"
              opacity="0.7"
              d="M340.26 240.28H314.75V265.79H340.26V240.28Z"
              fill="#FF3D33"
            />
            <path
              id="Vector_79"
              opacity="0.7"
              d="M340.26 272.59H314.75V298.1H340.26V272.59Z"
              fill="#FF3D33"
            />
            <path
              id="Vector_80"
              opacity="0.7"
              d="M131.06 304.91H105.55V330.42H131.06V304.91Z"
              fill="#FF3D33"
            />
            <path
              id="Vector_81"
              opacity="0.7"
              d="M165.93 304.91H140.42V330.42H165.93V304.91Z"
              fill="#FF3D33"
            />
            <path
              id="Vector_82"
              opacity="0.7"
              d="M200.79 304.91H175.28V330.42H200.79V304.91Z"
              fill="#FF3D33"
            />
            <path
              id="Vector_83"
              opacity="0.7"
              d="M235.66 304.91H210.15V330.42H235.66V304.91Z"
              fill="#FF3D33"
            />
            <path
              id="Vector_84"
              opacity="0.7"
              d="M270.53 304.91H245.02V330.42H270.53V304.91Z"
              fill="#FF3D33"
            />
            <path
              id="Vector_85"
              opacity="0.7"
              d="M828.38 175.65H802.87V201.16H828.38V175.65Z"
              fill="#FF3D33"
            />
            <path
              id="Vector_86"
              opacity="0.4"
              d="M410 143.33H384.48V168.84H410V143.33Z"
              fill="#FF3D33"
            />
            <path
              id="Vector_87"
              opacity="0.4"
              d="M410 175.65H384.48V201.16H410V175.65Z"
              fill="#FF3D33"
            />
          </g>
          <g id="High light">
            <path
              id="Vector_88"
              d="M444.86 111.02H419.35V136.53H444.86V111.02Z"
              fill="#D60B00"
            />
            <path
              id="Vector_89"
              d="M444.86 143.33H419.35V168.84H444.86V143.33Z"
              fill="#D60B00"
            />
            <path
              id="Vector_90"
              d="M584.32 143.33H558.81V168.84H584.32V143.33Z"
              fill="#D60B00"
            />
            <path
              id="Vector_91"
              d="M584.32 175.65H558.81V201.16H584.32V175.65Z"
              fill="#D60B00"
            />
            <path
              id="Vector_92"
              d="M932.98 143.33H907.47V168.84H932.98V143.33Z"
              fill="#D60B00"
            />
            <path
              id="Vector_93"
              d="M932.98 175.65H907.47V201.16H932.98V175.65Z"
              fill="#D60B00"
            />
            <path
              id="Vector_94"
              d="M967.85 111.02H942.34V136.53H967.85V111.02Z"
              fill="#D60B00"
            />
            <path
              id="Vector_95"
              d="M967.85 143.33H942.34V168.84H967.85V143.33Z"
              fill="#D60B00"
            />
            <path
              id="Vector_96"
              d="M967.85 175.65H942.34V201.16H967.85V175.65Z"
              fill="#D60B00"
            />
            <path
              id="Vector_97"
              d="M270.53 143.33H245.02V168.84H270.53V143.33Z"
              fill="#D60B00"
            />
            <path
              id="Vector_98"
              d="M270.53 175.65H245.02V201.16H270.53V175.65Z"
              fill="#D60B00"
            />
            <path
              id="Vector_99"
              d="M270.53 207.96H245.02V233.47H270.53V207.96Z"
              fill="#D60B00"
            />
            <path
              id="Vector_100"
              opacity="0.7"
              d="M863.25 207.96H837.74V233.47H863.25V207.96Z"
              fill="#D60B00"
            />
            <path
              id="Vector_101"
              opacity="0.7"
              d="M898.12 207.96H872.61V233.47H898.12V207.96Z"
              fill="#D60B00"
            />
            <path
              id="Vector_102"
              opacity="0.7"
              d="M898.12 240.28H872.61V265.79H898.12V240.28Z"
              fill="#D60B00"
            />
            <path
              id="Vector_103"
              d="M1002.71 111.02H977.2V136.53H1002.71V111.02Z"
              fill="#D60B00"
            />
            <path
              id="Vector_104"
              d="M1002.71 143.33H977.2V168.84H1002.71V143.33Z"
              fill="#D60B00"
            />
            <path
              id="Vector_105"
              d="M1002.71 175.65H977.2V201.16H1002.71V175.65Z"
              fill="#D60B00"
            />
            <path
              id="Vector_106"
              d="M1002.71 207.96H977.2V233.47H1002.71V207.96Z"
              fill="#D60B00"
            />
            <path
              id="Vector_107"
              d="M1002.71 240.28H977.2V265.79H1002.71V240.28Z"
              fill="#D60B00"
            />
            <path
              id="Vector_108"
              d="M1002.71 272.59H977.2V298.1H1002.71V272.59Z"
              fill="#D60B00"
            />
            <path
              id="Vector_109"
              d="M1002.71 304.91H977.2V330.42H1002.71V304.91Z"
              fill="#D60B00"
            />
            <path
              id="Vector_110"
              d="M549.45 240.28H523.94V265.79H549.45V240.28Z"
              fill="#D60B00"
            />
            <path
              id="Vector_111"
              d="M584.32 240.28H558.81V265.79H584.32V240.28Z"
              fill="#D60B00"
            />
            <path
              id="Vector_112"
              d="M619.19 240.28H593.68V265.79H619.19V240.28Z"
              fill="#D60B00"
            />
            <path
              id="Vector_113"
              d="M549.45 272.59H523.94V298.1H549.45V272.59Z"
              fill="#D60B00"
            />
            <path
              id="Vector_114"
              d="M584.32 272.59H558.81V298.1H584.32V272.59Z"
              fill="#D60B00"
            />
            <path
              id="Vector_115"
              opacity="0.2"
              d="M619.19 272.59H593.68V298.1H619.19V272.59Z"
              fill="#D60B00"
            />
            <path
              id="Vector_116"
              d="M479.72 240.28H454.21V265.79H479.72V240.28Z"
              fill="#D60B00"
            />
            <path
              id="Vector_117"
              d="M479.72 272.59H454.21V298.1H479.72V272.59Z"
              fill="#D60B00"
            />
            <path
              id="Vector_118"
              d="M828.38 111.02H802.87V136.53H828.38V111.02Z"
              fill="#D60B00"
            />
            <path
              id="Vector_119"
              d="M863.25 111.02H837.74V136.53H863.25V111.02Z"
              fill="#D60B00"
            />
            <path
              id="Vector_120"
              d="M200.79 175.65H175.28V201.16H200.79V175.65Z"
              fill="#D60B00"
            />
            <path
              id="Vector_121"
              opacity="0.7"
              d="M235.66 175.65H210.15V201.16H235.66V175.65Z"
              fill="#D60B00"
            />
            <path
              id="Vector_122"
              d="M479.72 175.65H454.21V201.16H479.72V175.65Z"
              fill="#D60B00"
            />
            <path
              id="Vector_123"
              d="M514.59 207.96H489.08V233.47H514.59V207.96Z"
              fill="#D60B00"
            />
            <path
              id="Vector_124"
              d="M514.59 304.91H489.08V330.42H514.59V304.91Z"
              fill="#D60B00"
            />
            <path
              id="Vector_125"
              d="M654.05 304.91H628.54V330.42H654.05V304.91Z"
              fill="#D60B00"
            />
          </g>
          <g id="low light">
            <path
              id="Vector_126"
              opacity="0.2"
              d="M305.39 304.91H279.88V330.42H305.39V304.91Z"
              fill="#FF6961"
            />
            <path
              id="Vector_127"
              opacity="0.2"
              d="M340.26 304.91H314.75V330.42H340.26V304.91Z"
              fill="#FF6961"
            />
            <path
              id="Vector_128"
              opacity="0.2"
              d="M375.12 304.91H349.61V330.42H375.12V304.91Z"
              fill="#FF6961"
            />
            <path
              id="Vector_129"
              opacity="0.2"
              d="M409.99 304.91H384.48V330.42H409.99V304.91Z"
              fill="#FF6961"
            />
            <path
              id="Vector_130"
              opacity="0.2"
              d="M444.86 304.91H419.35V330.42H444.86V304.91Z"
              fill="#FF6961"
            />
            <path
              id="Vector_131"
              opacity="0.2"
              d="M479.72 304.91H454.21V330.42H479.72V304.91Z"
              fill="#FF6961"
            />
            <path
              id="Vector_132"
              opacity="0.2"
              d="M375.12 111.02H349.61V136.53H375.12V111.02Z"
              fill="#FF6961"
            />
            <path
              id="Vector_133"
              opacity="0.2"
              d="M375.12 143.33H349.61V168.84H375.12V143.33Z"
              fill="#FF6961"
            />
            <path
              id="Vector_134"
              opacity="0.2"
              d="M375.12 175.65H349.61V201.16H375.12V175.65Z"
              fill="#FF6961"
            />
            <path
              id="Vector_135"
              opacity="0.2"
              d="M375.12 207.96H349.61V233.47H375.12V207.96Z"
              fill="#FF6961"
            />
            <path
              id="Vector_136"
              opacity="0.2"
              d="M375.12 240.28H349.61V265.79H375.12V240.28Z"
              fill="#FF6961"
            />
            <path
              id="Vector_137"
              opacity="0.2"
              d="M375.12 272.59H349.61V298.1H375.12V272.59Z"
              fill="#FF6961"
            />
            <path
              id="Vector_138"
              opacity="0.2"
              d="M131.06 183.33V201.16H105.55V192.45C113.804 188.754 122.333 185.704 131.06 183.33V183.33Z"
              fill="#FF6961"
            />
            <path
              id="Vector_139"
              opacity="0.2"
              d="M131.06 207.96H105.55V233.47H131.06V207.96Z"
              fill="#FF6961"
            />
            <path
              id="Vector_140"
              opacity="0.2"
              d="M131.06 240.28H105.55V265.79H131.06V240.28Z"
              fill="#FF6961"
            />
            <path
              id="Vector_141"
              opacity="0.2"
              d="M131.06 272.59H105.55V298.1H131.06V272.59Z"
              fill="#FF6961"
            />
            <path
              id="Vector_142"
              opacity="0.2"
              d="M165.93 177.57V201.16H140.42V181.07L165.93 177.57Z"
              fill="#FF6961"
            />
            <path
              id="Vector_143"
              opacity="0.2"
              d="M165.93 207.96H140.42V233.47H165.93V207.96Z"
              fill="#FF6961"
            />
            <path
              id="Vector_144"
              opacity="0.2"
              d="M165.93 240.28H140.42V265.79H165.93V240.28Z"
              fill="#FF6961"
            />
            <path
              id="Vector_145"
              opacity="0.2"
              d="M165.93 272.59H140.42V298.1H165.93V272.59Z"
              fill="#FF6961"
            />
            <path
              id="Vector_146"
              opacity="0.2"
              d="M200.79 207.96H175.28V233.47H200.79V207.96Z"
              fill="#FF6961"
            />
            <path
              id="Vector_147"
              opacity="0.2"
              d="M200.79 272.59H175.28V298.1H200.79V272.59Z"
              fill="#FF6961"
            />
            <path
              id="Vector_148"
              opacity="0.2"
              d="M235.66 240.28H210.15V265.79H235.66V240.28Z"
              fill="#FF6961"
            />
            <path
              id="Vector_149"
              opacity="0.2"
              d="M270.53 240.28H245.02V265.79H270.53V240.28Z"
              fill="#FF6961"
            />
            <path
              id="Vector_150"
              opacity="0.2"
              d="M270.53 272.59H245.02V298.1H270.53V272.59Z"
              fill="#FF6961"
            />
            <path
              id="Vector_151"
              opacity="0.2"
              d="M410 111.02H384.48V136.53H410V111.02Z"
              fill="#FF6961"
            />
            <path
              id="Vector_152"
              opacity="0.2"
              d="M410 207.96H384.48V233.47H410V207.96Z"
              fill="#FF6961"
            />
            <path
              id="Vector_153"
              opacity="0.2"
              d="M410 240.28H384.48V265.79H410V240.28Z"
              fill="#FF6961"
            />
            <path
              id="Vector_154"
              opacity="0.2"
              d="M410 272.59H384.48V298.1H410V272.59Z"
              fill="#FF6961"
            />
            <path
              id="Vector_155"
              opacity="0.2"
              d="M270.53 111.02H245.02V136.53H270.53V111.02Z"
              fill="#FF6961"
            />
            <path
              id="Vector_156"
              opacity="0.2"
              d="M305.39 111.02H279.88V136.53H305.39V111.02Z"
              fill="#FF6961"
            />
            <path
              id="Vector_157"
              opacity="0.2"
              d="M340.26 111.02H314.75V136.53H340.26V111.02Z"
              fill="#FF6961"
            />
            <path
              id="Vector_158"
              opacity="0.2"
              d="M479.72 111.02H454.21V136.53H479.72V111.02Z"
              fill="#FF6961"
            />
            <path
              id="Vector_159"
              opacity="0.2"
              d="M793.52 111.02H768.01V136.53H793.52V111.02Z"
              fill="#FF6961"
            />
            <path
              id="Vector_160"
              opacity="0.2"
              d="M898.12 111.02H872.61V136.53H898.12V111.02Z"
              fill="#FF6961"
            />
            <path
              id="Vector_161"
              opacity="0.2"
              d="M932.98 111.02H907.47V136.53H932.98V111.02Z"
              fill="#FF6961"
            />
            <path
              id="Vector_162"
              opacity="0.2"
              d="M305.39 143.33H279.88V168.84H305.39V143.33Z"
              fill="#FF6961"
            />
            <path
              id="Vector_163"
              opacity="0.2"
              d="M514.59 143.33H489.08V168.84H514.59V143.33Z"
              fill="#FF6961"
            />
            <path
              id="Vector_164"
              opacity="0.2"
              d="M688.92 143.33H663.41V168.84H688.92V143.33Z"
              fill="#FF6961"
            />
            <path
              id="Vector_165"
              opacity="0.2"
              d="M793.52 143.33H768.01V168.84H793.52V143.33Z"
              fill="#FF6961"
            />
            <path
              id="Vector_166"
              opacity="0.2"
              d="M828.38 143.33H802.87V168.84H828.38V143.33Z"
              fill="#FF6961"
            />
            <path
              id="Vector_167"
              opacity="0.2"
              d="M898.12 143.33H872.61V168.84H898.12V143.33Z"
              fill="#FF6961"
            />
            <path
              id="Vector_168"
              opacity="0.2"
              d="M235.66 116.18V136.53H216.66C222.613 129.543 228.947 122.76 235.66 116.18Z"
              fill="#FF6961"
            />
            <path
              id="Vector_169"
              opacity="0.2"
              d="M235.66 143.33H210.15V168.84H235.66V143.33Z"
              fill="#FF6961"
            />
            <path
              id="Vector_170"
              opacity="0.2"
              d="M514.59 175.65H489.08V201.16H514.59V175.65Z"
              fill="#FF6961"
            />
            <path
              id="Vector_171"
              opacity="0.2"
              d="M619.19 175.65H593.68V201.16H619.19V175.65Z"
              fill="#FF6961"
            />
            <path
              id="Vector_172"
              opacity="0.2"
              d="M898.12 175.65H872.61V201.16H898.12V175.65Z"
              fill="#FF6961"
            />
            <path
              id="Vector_173"
              opacity="0.2"
              d="M235.66 207.96H210.15V233.47H235.66V207.96Z"
              fill="#FF6961"
            />
            <path
              id="Vector_174"
              opacity="0.2"
              d="M549.45 207.96H523.94V233.47H549.45V207.96Z"
              fill="#FF6961"
            />
            <path
              id="Vector_175"
              opacity="0.2"
              d="M828.38 207.96H802.87V233.47H828.38V207.96Z"
              fill="#FF6961"
            />
            <path
              id="Vector_176"
              opacity="0.2"
              d="M967.85 207.96H942.34V233.47H967.85V207.96Z"
              fill="#FF6961"
            />
            <path
              id="Vector_177"
              opacity="0.2"
              d="M514.59 240.28H489.08V265.79H514.59V240.28Z"
              fill="#FF6961"
            />
            <path
              id="Vector_178"
              opacity="0.2"
              d="M828.38 240.28H802.87V265.79H828.38V240.28Z"
              fill="#FF6961"
            />
            <path
              id="Vector_179"
              opacity="0.2"
              d="M863.25 240.28H837.74V265.79H863.25V240.28Z"
              fill="#FF6961"
            />
            <path
              id="Vector_180"
              opacity="0.2"
              d="M932.98 240.28H907.47V265.79H932.98V240.28Z"
              fill="#FF6961"
            />
            <path
              id="Vector_181"
              opacity="0.2"
              d="M967.85 240.28H942.34V265.79H967.85V240.28Z"
              fill="#FF6961"
            />
            <path
              id="Vector_182"
              opacity="0.2"
              d="M514.59 111.02H489.08V136.53H514.59V111.02Z"
              fill="#FF6961"
            />
            <path
              id="Vector_183"
              opacity="0.2"
              d="M549.45 111.02H523.94V136.53H549.45V111.02Z"
              fill="#FF6961"
            />
            <path
              id="Vector_184"
              opacity="0.2"
              d="M619.19 111.02H593.68V136.53H619.19V111.02Z"
              fill="#FF6961"
            />
            <path
              id="Vector_185"
              opacity="0.2"
              d="M654.05 111.02H628.54V136.53H654.05V111.02Z"
              fill="#FF6961"
            />
            <path
              id="Vector_186"
              opacity="0.2"
              d="M688.92 111.02H663.41V136.53H688.92V111.02Z"
              fill="#FF6961"
            />
            <path
              id="Vector_187"
              opacity="0.2"
              d="M723.79 111.02H698.28V136.53H723.79V111.02Z"
              fill="#FF6961"
            />
            <path
              id="Vector_188"
              opacity="0.2"
              d="M758.65 111.02H733.14V136.53H758.65V111.02Z"
              fill="#FF6961"
            />
            <path
              id="Vector_189"
              opacity="0.2"
              d="M305.39 272.59H279.88V298.1H305.39V272.59Z"
              fill="#FF6961"
            />
            <path
              id="Vector_190"
              opacity="0.2"
              d="M514.59 272.59H489.08V298.1H514.59V272.59Z"
              fill="#FF6961"
            />
            <path
              id="Vector_191"
              opacity="0.2"
              d="M654.05 272.59H628.54V298.1H654.05V272.59Z"
              fill="#FF6961"
            />
            <path
              id="Vector_192"
              opacity="0.2"
              d="M828.38 272.59H802.87V298.1H828.38V272.59Z"
              fill="#FF6961"
            />
            <path
              id="Vector_193"
              opacity="0.2"
              d="M863.25 272.59H837.74V298.1H863.25V272.59Z"
              fill="#FF6961"
            />
            <path
              id="Vector_194"
              opacity="0.2"
              d="M898.12 272.59H872.61V298.1H898.12V272.59Z"
              fill="#FF6961"
            />
            <path
              id="Vector_195"
              opacity="0.2"
              d="M932.98 272.59H907.47V298.1H932.98V272.59Z"
              fill="#FF6961"
            />
            <path
              id="Vector_196"
              opacity="0.2"
              d="M549.45 304.91H523.94V330.42H549.45V304.91Z"
              fill="#FF6961"
            />
            <path
              id="Vector_197"
              opacity="0.2"
              d="M584.32 304.91H558.81V330.42H584.32V304.91Z"
              fill="#FF6961"
            />
            <path
              id="Vector_198"
              opacity="0.2"
              d="M619.19 304.91H593.68V330.42H619.19V304.91Z"
              fill="#FF6961"
            />
            <path
              id="Vector_199"
              opacity="0.2"
              d="M967.85 304.91H942.34V330.42H967.85V304.91Z"
              fill="#FF6961"
            />
          </g>
          <path
            id="Vector_200"
            d="M722.897 251.909C731.567 255.099 736.697 264.059 744.477 269.049C755.477 276.049 769.797 274.239 782.357 270.779C789.357 268.869 796.677 266.539 803.567 268.659C804.58 269.108 805.698 269.267 806.797 269.119C808.297 268.689 809.037 267.029 809.527 265.549C818.047 240.149 814.217 211.379 801.357 187.879C798.037 181.819 794.057 175.959 788.577 171.749C784.257 168.439 779.177 166.269 774.057 164.419C764.7 161.059 755.022 158.669 745.177 157.289C743.438 156.973 741.662 156.916 739.907 157.119C737.497 157.509 735.337 158.809 733.187 159.969C723.978 164.905 713.767 167.679 703.327 168.079C689.327 168.609 673.327 165.309 662.537 174.289C649.537 185.059 652.777 206.069 644.347 220.689C638.767 230.359 628.007 237.379 626.237 248.389C625.776 251.754 625.99 255.177 626.867 258.459C630.987 275.399 647.387 288.519 664.867 288.829C667.551 289.034 670.239 288.483 672.627 287.239C674.191 286.172 675.572 284.858 676.717 283.349C688.167 269.789 701.267 243.949 722.897 251.909Z"
            fill="#444053"
          />
        </g>
        <defs>
          <filter
            id="filter0_d"
            x="-4.00049"
            y="0.0400085"
            width="1152"
            height="624.871"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            />
            <feOffset dy="4" />
            <feGaussianBlur stdDeviation="2" />
            <feColorMatrix
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
            />
            <feBlend
              mode="normal"
              in2="BackgroundImageFix"
              result="effect1_dropShadow"
            />
            <feBlend
              mode="normal"
              in="SourceGraphic"
              in2="effect1_dropShadow"
              result="shape"
            />
          </filter>
          <clipPath id="clip0">
            <rect width="1144" height="617.32" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </CodingStyle>
  )
}

export default coding
